__turbopack_context__.v({
  "engagement": "RoundInfo-module__RDgtHG__engagement",
  "roundInfo": "RoundInfo-module__RDgtHG__roundInfo",
  "roundName": "RoundInfo-module__RDgtHG__roundName",
  "section": "RoundInfo-module__RDgtHG__section",
  "submissionList": "RoundInfo-module__RDgtHG__submissionList",
  "trend": "RoundInfo-module__RDgtHG__trend",
  "trendingIconDown": "RoundInfo-module__RDgtHG__trendingIconDown",
  "trendingIconUp": "RoundInfo-module__RDgtHG__trendingIconUp",
  "voteStats": "RoundInfo-module__RDgtHG__voteStats",
  "voteStatsSubrow": "RoundInfo-module__RDgtHG__voteStatsSubrow",
});
